import { EntitiesQuery } from '../../../core/state/entities.query';
import { IUser } from '../models/user.model';
import { usersStore } from './users.store';

export class UsersQuery extends EntitiesQuery<IUser> {}

export const usersQuery = new UsersQuery(usersStore);
